{
  "header": {
    "title": "Contract Mapping",
    "description": "Create and review contract mappings for generating companies, units, buyers, and PSS links."
  },
  "buyerTypes": ["Utility", "Consumer"],
  "contractTypes": ["PPA", "EPA", "Open Access"],
  "consumers": [
    { "code": "CON-001", "name": "XYZ Steel" },
    { "code": "CON-002", "name": "Sterling Steel" },
    { "code": "CON-003", "name": "Jindal Steel" },
    { "code": "CON-004", "name": "Green Alloy Works" },
    { "code": "CON-005", "name": "Aurora Cement" },
    { "code": "CON-006", "name": "Prime Metals" },
    { "code": "CON-007", "name": "Western Industrial Park" }
  ],
  "utilities": [
    { "code": "UTL-001", "name": "MSEDCL" },
    { "code": "UTL-002", "name": "BEST" },
    { "code": "UTL-003", "name": "GETCO" },
    { "code": "UTL-004", "name": "JVVNL" },
    { "code": "UTL-005", "name": "TATA" },
    { "code": "UTL-006", "name": "TPC-D" },
    { "code": "UTL-007", "name": "CESC" }
  ],
  "pssOptions": [
    { "code": "PSS-001", "name": "Ahmednagar PSS 1" },
    { "code": "PSS-004", "name": "Kolhapur PSS 4" },
    { "code": "PSS-007", "name": "Nashik PSS 7" },
    { "code": "PSS-008", "name": "Amravati PSS 8" },
    { "code": "PSS-009", "name": "Kolhapur PSS 9" }
  ],
  "generatingCompanies": [
    { "code": "GEN-001", "name": "SolarOne Plant 1" },
    { "code": "GEN-004", "name": "SolarOne Plant 4" },
    { "code": "GEN-007", "name": "GreenWind Plant 7" },
    { "code": "GEN-008", "name": "SunPower Plant 8" },
    { "code": "GEN-009", "name": "EcoHybrid Plant 9" }
  ],
  "generatingUnits": [
    { "code": "UNIT-1001", "name": "UNIT-1001", "generatingCompanyCode": "GEN-001", "generatingCompanyName": "SolarOne Plant 1", "pssCode": "PSS-001", "pssName": "Ahmednagar PSS 1" },
    { "code": "UNIT-1002", "name": "UNIT-1002", "generatingCompanyCode": "GEN-001", "generatingCompanyName": "SolarOne Plant 1", "pssCode": "PSS-001", "pssName": "Ahmednagar PSS 1" },
    { "code": "UNIT-4001", "name": "UNIT-4001", "generatingCompanyCode": "GEN-004", "generatingCompanyName": "SolarOne Plant 4", "pssCode": "PSS-004", "pssName": "Kolhapur PSS 4" },
    { "code": "UNIT-4002", "name": "UNIT-4002", "generatingCompanyCode": "GEN-004", "generatingCompanyName": "SolarOne Plant 4", "pssCode": "PSS-004", "pssName": "Kolhapur PSS 4" },
    { "code": "UNIT-7001", "name": "UNIT-7001", "generatingCompanyCode": "GEN-007", "generatingCompanyName": "GreenWind Plant 7", "pssCode": "PSS-007", "pssName": "Nashik PSS 7" },
    { "code": "UNIT-8001", "name": "UNIT-8001", "generatingCompanyCode": "GEN-008", "generatingCompanyName": "SunPower Plant 8", "pssCode": "PSS-008", "pssName": "Amravati PSS 8" },
    { "code": "UNIT-9001", "name": "UNIT-9001", "generatingCompanyCode": "GEN-009", "generatingCompanyName": "EcoHybrid Plant 9", "pssCode": "PSS-009", "pssName": "Kolhapur PSS 9" },
    { "code": "UNIT-9002", "name": "UNIT-9002", "generatingCompanyCode": "GEN-009", "generatingCompanyName": "EcoHybrid Plant 9", "pssCode": "PSS-009", "pssName": "Kolhapur PSS 9" }
  ],
  "contractMappings": [
    {
      "id": 1,
      "generatingCompanyCode": "GEN-001",
      "generatingCompanyName": "SolarOne Plant 1",
      "generatingUnitCode": "UNIT-1001",
      "generatingUnitName": "UNIT-1001",
      "buyerType": "Utility",
      "buyerName": "TATA",
      "contractType": "PPA",
      "contractCapacityMw": 10,
      "contractRate": 4,
      "effectiveFrom": "2026-02-01",
      "effectiveTo": "2026-10-31",
      "pssCode": "PSS-001",
      "pssName": "Ahmednagar PSS 1"
    },
    {
      "id": 2,
      "generatingCompanyCode": "GEN-001",
      "generatingCompanyName": "SolarOne Plant 1",
      "generatingUnitCode": "UNIT-1001",
      "generatingUnitName": "UNIT-1001",
      "buyerType": "Consumer",
      "buyerName": "XYZ Steel",
      "contractType": "PPA",
      "contractCapacityMw": 7,
      "contractRate": 3,
      "effectiveFrom": "2026-02-01",
      "effectiveTo": "2026-05-31",
      "pssCode": "PSS-001",
      "pssName": "Ahmednagar PSS 1"
    },
    {
      "id": 3,
      "generatingCompanyCode": "GEN-001",
      "generatingCompanyName": "SolarOne Plant 1",
      "generatingUnitCode": "UNIT-1002",
      "generatingUnitName": "UNIT-1002",
      "buyerType": "Consumer",
      "buyerName": "Sterling Steel",
      "contractType": "PPA",
      "contractCapacityMw": 20,
      "contractRate": 4,
      "effectiveFrom": "2026-02-01",
      "effectiveTo": "2026-10-31",
      "pssCode": "PSS-001",
      "pssName": "Ahmednagar PSS 1"
    },
    {
      "id": 4,
      "generatingCompanyCode": "GEN-004",
      "generatingCompanyName": "SolarOne Plant 4",
      "generatingUnitCode": "UNIT-4001",
      "generatingUnitName": "UNIT-4001",
      "buyerType": "Consumer",
      "buyerName": "Jindal Steel",
      "contractType": "PPA",
      "contractCapacityMw": 25,
      "contractRate": 3,
      "effectiveFrom": "2026-02-01",
      "effectiveTo": "2026-05-31",
      "pssCode": "PSS-004",
      "pssName": "Kolhapur PSS 4"
    },
    {
      "id": 5,
      "generatingCompanyCode": "GEN-007",
      "generatingCompanyName": "GreenWind Plant 7",
      "generatingUnitCode": "UNIT-7001",
      "generatingUnitName": "UNIT-7001",
      "buyerType": "Utility",
      "buyerName": "MSEDCL",
      "contractType": "EPA",
      "contractCapacityMw": 12.5,
      "contractRate": 3.75,
      "effectiveFrom": "2026-01-15",
      "effectiveTo": "2026-12-31",
      "pssCode": "PSS-007",
      "pssName": "Nashik PSS 7"
    },
    {
      "id": 6,
      "generatingCompanyCode": "GEN-008",
      "generatingCompanyName": "SunPower Plant 8",
      "generatingUnitCode": "UNIT-8001",
      "generatingUnitName": "UNIT-8001",
      "buyerType": "Consumer",
      "buyerName": "Aurora Cement",
      "contractType": "Open Access",
      "contractCapacityMw": 18,
      "contractRate": 4.25,
      "effectiveFrom": "2026-03-01",
      "effectiveTo": "2026-09-30",
      "pssCode": "PSS-008",
      "pssName": "Amravati PSS 8"
    }
  ]
}
